import { render } from "./AppKontakt.vue?vue&type=template&id=7128c0fd"
import script from "./AppKontakt.vue?vue&type=script&lang=js"
export * from "./AppKontakt.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__